var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoFullscreen({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9512 0.761721C12.9512 0.365372 13.2788 0.0440674 13.6829 0.0440674H15.5407C16.7223 0.0509861 17.8536 0.514263 18.6884 1.33361C19.5232 2.15299 19.9939 3.26217 19.9974 4.41993L19.9974 4.42207L19.9974 6.56556C19.9974 6.96191 19.6698 7.28321 19.2657 7.28321C18.8616 7.28321 18.534 6.96191 18.534 6.56556V4.4232C18.5313 3.64531 18.215 2.89956 17.6532 2.34815C17.0916 1.79694 16.3301 1.48457 15.534 1.47938H13.6829C13.2788 1.47938 12.9512 1.15807 12.9512 0.761721Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9512 19.2383C12.9512 19.6346 13.2788 19.9559 13.6829 19.9559H15.5407C16.7223 19.949 17.8536 19.4857 18.6884 18.6664C19.5232 17.847 19.9939 16.7378 19.9974 15.5801L19.9974 15.5779L19.9974 13.4344C19.9974 13.0381 19.6698 12.7168 19.2657 12.7168C18.8616 12.7168 18.534 13.0381 18.534 13.4344V15.5768C18.5313 16.3547 18.215 17.1004 17.6532 17.6518C17.0916 18.2031 16.3301 18.5154 15.534 18.5206H13.6829C13.2788 18.5206 12.9512 18.8419 12.9512 19.2383Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.45887 6.7423e-05L4.46106 6.10352e-05L6.34822 6.42291e-05C6.75233 6.42291e-05 7.07992 0.321369 7.07992 0.717718C7.07992 1.11407 6.75233 1.43537 6.34822 1.43537H4.46222C3.66719 1.43797 2.90579 1.74821 2.34408 2.29787C1.78245 2.84746 1.46607 3.59176 1.46341 4.36827V6.56557C1.46341 6.96192 1.13582 7.28322 0.731707 7.28322C0.327597 7.28322 0 6.96192 0 6.56557V4.36497C0.00354558 3.20787 0.474854 2.0995 1.31047 1.2818C2.14602 0.464157 3.27792 0.00353264 4.45887 6.7423e-05Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.45887 19.9999L4.46106 19.9999L6.34822 19.9999C6.75233 19.9999 7.07992 19.6786 7.07992 19.2823C7.07992 18.8859 6.75233 18.5646 6.34822 18.5646H4.46222C3.66719 18.562 2.90579 18.2518 2.34408 17.7021C1.78245 17.1525 1.46607 16.4082 1.46341 15.6317V13.4344C1.46341 13.0381 1.13582 12.7168 0.731707 12.7168C0.327597 12.7168 0 13.0381 0 13.4344V15.635C0.00354558 16.7921 0.474854 17.9005 1.31047 18.7182C2.14602 19.5358 3.27792 19.9965 4.45887 19.9999Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoFullscreen);
export default __webpack_public_path__ + "static/media/video_fullscreen.90ae8ca998adc537952cdbfda3b4c198.svg";
export { ForwardRef as ReactComponent };